<script setup lang="ts">
export interface DataItem {
  quantity: string;
  volume: string;
  weight: string;
  cubicWeight: string;
  isCubicWeightError: boolean;
}

export interface Props {
  data?: {
    carton: Partial<DataItem>;
    pallet: Partial<DataItem>;
  };
}
const props = withDefaults(defineProps<Props>(), {
  data: () => ({ carton: {}, pallet: {} }),
});
</script>

<template>
  <table
    data-testid="totalPackageStepNewAirRoadCustomTable"
    :class="$style.totalPackageStepNewAirRoadCustomTable"
  >
    <thead>
      <tr>
        <th :class="$style.typeTh">Type</th>
        <th :class="$style.quantityTh">Quantity</th>
        <th :class="$style.volumeTh">Volume (m³) </th>
        <th :class="$style.weightTh">Weight (kg)</th>
        <th :class="$style.cubicWeightTh">Cubic Weight (kg)</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th :class="$style.cartonTh">Carton</th>
        <td :class="$style.quantityTd">{{ props.data.carton.quantity }}</td>
        <td :class="$style.volumeTd">{{ props.data.carton.volume }}</td>
        <td :class="$style.weightTd">{{ props.data.carton.weight }}</td>
        <td
          :class="[
            $style.cubicWeightTd,
            { [$style.error]: props.data.carton.isCubicWeightError },
          ]"
        >
          {{ props.data.carton.cubicWeight }}
        </td>
      </tr>
      <tr>
        <th :class="$style.palletTh">Pallet</th>
        <td :class="$style.quantityTd">{{ props.data.pallet.quantity }}</td>
        <td :class="$style.volumeTd">{{ props.data.pallet.volume }}</td>
        <td :class="$style.weightTd">{{ props.data.pallet.weight }}</td>
        <td
          :class="[
            $style.cubicWeightTd,
            { [$style.error]: props.data.pallet.isCubicWeightError },
          ]"
        >
          {{ props.data.pallet.cubicWeight }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.totalPackageStepNewAirRoadCustomTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  text-align: left;

  & > thead > tr,
  & > tbody > tr,
  & > tr {
    & > th {
      font-weight: 500;
      padding: 4px 12px;
      vertical-align: baseline;
    }
    & > td {
      padding: 4px 12px;
      vertical-align: baseline;
    }
    & > th:first-child,
    & > td:first-child {
      padding-left: 0;
    }
    & > th:last-child,
    & > td:last-child {
      padding-right: 0;
    }
  }
}
  .typeTh {
  }
  .quantityTh {
    text-align: right;
  }
  .volumeTh {
    text-align: right;
  }
  .weightTh {
    text-align: right;
  }
  .cubicWeightTh {
    text-align: right;
  }
  .cartonTh, .palletTh {
  }
  .quantityTd {
    text-align: right;
  }
  .volumeTd {
    text-align: right;
  }
  .weightTd {
    text-align: right;
  }
  .cubicWeightTd {
    text-align: right;
  }
  .error {
    color: colors.$color-status-error-text;
  }
</style>
